export function resolveAvatarUrl(value) {
  const avatar = String(value || '').trim();
  if (!avatar) {
    return '';
  }
  if (/^(https?:)?\/\//i.test(avatar) || avatar.startsWith('/') || avatar.startsWith('data:image/') || avatar.startsWith('blob:')) {
    return avatar;
  }
  return '';
}

export function resolveAvatarText(value, fallback = 'WP') {
  const text = String(value || '').trim().slice(0, 2).toUpperCase();
  return text || fallback;
}
